function autofillVehicleinfo(vehicle, data) {
    vehicle.vin = data.vin;
    vehicle.make = data.make;
    vehicle.model = data.model;
    vehicle.color = data.color;
    vehicle.year = data.year;
    vehicle.manufactureDate = data.manufactureDate;
    vehicle.bodyStyle = data.bodyStyle;
    vehicle.seatingCapacityInclDriver = data.seatingCapacityInclDriver;
    vehicle.cherisherTransferDate = data.cherisherTransferDate;
    vehicle.cherishedTransferMarker = data.cherishedTransferMarker;
    vehicle.combinedEngineCapacity = data.combinedEngineCapacity;
    vehicle.combinedTransmission = data.combinedTransmission;
    vehicle.fuelType = data.fuelType;
    vehicle.heightMM = data.heightMM;
    vehicle.introductionDateToUK = data.introductionDateToUK;
    vehicle.kerbWeightMax = data.kerbWeightMax;
    vehicle.lengthMM = data.lengthMM;
    vehicle.numberOfPreviousKeepers = data.numberOfPreviousKeepers;
    vehicle.startDateOfCurrentKeeper = data.startDateOfCurrentKeeper;
    vehicle.transmission = data.transmission;
    vehicle.widthMM = data.widthMM;
    vehicle.yearRegister = data.yearRegister;
    vehicle.vehicleRegDate = data.vehicleRegDate;
    vehicle.valuationCode = data.valuationCode;
    vehicle.pNCTheftNotifyDate = data.pNCTheftNotifyDate;
    vehicle.pNCTheftReporter = data.pNCTheftReporter;
    vehicle.importMarker = data.importMarker;
    vehicle.scrappingMarker = data.scrappingMarker;
    vehicle.scrappingDate = data.scrappingDate;
    vehicle.groupRating = data.groupRating;
    vehicle.aBI2 = data.abi2 || data.aBI2;
    vehicle.aBICategory = data.abicategory || data.aBICategory;

}

function removeVehicleInfo(vehicle) {
    vehicle.vin = undefined;
    vehicle.make = undefined;
    vehicle.model = undefined;
    vehicle.color = undefined;
    vehicle.year = undefined;
    vehicle.manufactureDate = undefined;
    vehicle.bodyStyle = undefined;
    vehicle.seatingCapacityInclDriver = undefined;
    vehicle.cherisherTransferDate = undefined;
    vehicle.cherishedTransferMarker = undefined;
    vehicle.combinedEngineCapacity = undefined;
    vehicle.combinedTransmission = undefined;
    vehicle.fuelType = undefined;
    vehicle.heightMM = undefined;
    vehicle.introductionDateToUK = undefined;
    vehicle.kerbWeightMax = undefined;
    vehicle.lengthMM = undefined;
    vehicle.numberOfPreviousKeepers = undefined;
    vehicle.startDateOfCurrentKeeper = undefined;
    vehicle.transmission = undefined;
    vehicle.widthMM = undefined;
    vehicle.yearRegister = undefined;
    vehicle.vehicleRegDate = undefined;
    vehicle.valuationCode = undefined;
    vehicle.pNCTheftNotifyDate = undefined;
    vehicle.pNCTheftReporter = undefined;
    vehicle.importMarker = undefined;
    vehicle.scrappingMarker = undefined;
    vehicle.scrappingDate = undefined;
    vehicle.groupRating = undefined;
    vehicle.aBI2 = undefined;
    vehicle.aBICategory = undefined;
    vehicle.availableOnCarweblookup = undefined;

}

function setTrailerVehicleInfo(vehicleIncident) {
    const insuredVehicleIncident = vehicleIncident.ClaimExtension.vehicleIncidents[0];
    vehicleIncident.category_Ext = 'trailer_container';
    vehicleIncident.fleetDepot_Ext = insuredVehicleIncident.fleetDepot_Ext;
    vehicleIncident.employeeDepot_Ext = insuredVehicleIncident.employeeDepot_Ext;
    vehicleIncident.vatIncluded_Ext = insuredVehicleIncident.vatIncluded_Ext;
    vehicleIncident.vatStatusIndicator_Ext = insuredVehicleIncident.vatStatusIndicator_Ext;
    vehicleIncident.vatRate_Ext = insuredVehicleIncident.vatRate_Ext;
    removeVehicleInfo(vehicleIncident.vehicle);
    vehicleIncident.vehicle.licensePlate = 'TRAILER';
    vehicleIncident.driver = insuredVehicleIncident.driver;
    vehicleIncident.driver.licenceType_Ext = insuredVehicleIncident.driver.licenceType_Ext;
    if (vehicleIncident.driver.licenceType_Ext === undefined && insuredVehicleIncident.driver.fullUKLicense_Ext) {
        vehicleIncident.driver.licenceType_Ext = 'F';
    }
}

function removeTrailerVehicleInfo(vehicleIncident) {
    vehicleIncident.category_Ext = null;
    vehicleIncident.fleetDepot_Ext = null;
    vehicleIncident.employeeDepot_Ext = null;
    vehicleIncident.vatIncluded_Ext = null;
    vehicleIncident.vatRate_Ext = null;
    vehicleIncident.vatStatusIndicator_Ext = null;
    vehicleIncident.vehicle.licensePlate = null;
    vehicleIncident.driver = null;
    removeVehicleInfo(vehicleIncident.vehicle);
    vehicleIncident.vehicle.licensePlate = null;

}

function getTypeList(index) {
    if (index === 0) {
        return [{
            id: 'insured',
            displayName: {
                id: 'insured',
                defaultMessage: 'Insured'
            }
        },
        {
            id: 'third_party',
            displayName: {
                id: 'third_party',
                defaultMessage: 'Third Party'
            }
        }]
    } else {
        return [{
            id: 'insured',
            displayName: {
                id: 'insured',
                defaultMessage: 'Insured Trailer'
            }
        },
        {
            id: 'third_party',
            displayName: {
                id: 'third_party',
                defaultMessage: 'Third Party'
            }
        }]
    }
}
var motorConvictionList = ["AA00", "AC10", "AC12", "AC14", "AC16", "AC20", "AC22", "AC24", "AC26", "AC30", "AC32", "AC34", "AC36",
    "MR09", "MR19", "MR29", "MR49", "MR59", "BA10", "BA12", "BA14", "BA16", "BA20", "BA22", "BA24", "BA26", "BA30", "BA32", "BA34", "BA36",
    "BA40", "BA60", "CD40", "CD42", "CD44", "CD46", "CD50", "CD52", "CD54", "CD56", "CD60", "CD62", "CD64", "CD66",
    "CD70", "CD71", "CD72", "CD74", "CD76", "CD80", "CD82", "CD84", "CD86", "CD90", "CD92", "CD94", "CD96", "DD10", "DD12",
    "DD14", "DD16", "DD30", "DD32", "DD34", "DD36", "DD40", "DD42", "DD44", "DD46", "DD60", "DD62", "DD64", "DD66", "DD70", "DD72", "DD74", "DD76",
    "DD80", "DD82", "DD84", "DD86", "DD90", "DD92", "DD94", "DD96", "DG10", "DG12", "DG14", "DG16", "DG40", "DG42", "DG44", "DG46", "DG60", "DG62",
    "DG64", "DG66", "DR10", "DR12", "DR14", "DR16", "DR20", "DR22", "DR24", "DR26", "DR30", "DR31", "DR32", "DR34", "DR36", "DR40", "DR42", "DR44",
    "DR46", "DR50", "DR52", "DR54", "DR56", "DR60", "DR61", "DR62", "DR64", "DR66", "DR70", "DR72", "DR74", "DR76", "DR80", "DR82", "DR84", "DR86",
    "DR90", "DR92", "DR94", "DR96", "IN10", "IN12", "IN14", "IN16", "LC30", "LC32", "LC34", "LC36", "LC40", "LC42", "LC44", "LC46", "LC50", "LC52",
    "LC54", "LC56", "MS40", "MS42", "MS44", "MS46", "MS50", "MS52", "MS54", "MS56", "MS60", "MS62", "MS64", "MS66", "MS70", "MS72", "MS74", "MS76",
    "MS80", "MS82", "MS84", "MS86", "MS90", "MS92", "MS94", "MS96", "UT10", "UT12", "UT14", "UT16", "UT20", "UT22", "UT24", "UT26", "UT30", "UT32",
    "UT34", "UT36", "UT40", "UT42", "UT44", "UT46", "UT50", "UT52", "UT54", "UT56", "TT99", "XX99", "BA42", "BA44", "BA46", "BA62", "BA64", "BA66"];

const availableVehicleStatuses = ['Veh_NotDamage', 'Veh_repairerbook', 'Veh_usable', 'No_repairs_required', 'Veh_repaired', 'Veh_recovered'];

const checkIsEmptyValue = (value) => {
    return value === undefined || value === null || value === NaN || value === '';

};

export default {
    autofillVehicleinfo: autofillVehicleinfo,
    removeVehicleinfo: removeVehicleInfo,
    setTrailerVehicleInfo: setTrailerVehicleInfo,
    removeTrailerVehicleInfo: removeTrailerVehicleInfo,
    getTypeList: getTypeList,
    motorConvictionList: motorConvictionList,
    availableVehicleStatuses: availableVehicleStatuses,
    checkIsEmptyValue: checkIsEmptyValue
}